import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function ErrorMessage({ error, message, description }) {
  return (
    <div>
      <Alert variant="outlined" severity="error">
        <AlertTitle>Error</AlertTitle>
        {message || description}
      </Alert>
    </div>
  );
}

export default ErrorMessage;
